import {FC} from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import RichText from "../../../components/content/RichText";
import {useNavigate} from "react-router-dom";
import useAsset from "../../../hooks/useasset";
import useFallbackImage from "../../../hooks/useFallbackImage";

type Props={
    title?: string;
    thumbnail?: string;
    description?: string;
    originalPath?: string;
}

const CodeDetailsRelatedContentContentSimple: FC<Props> = ({ title, thumbnail, description,originalPath }) => {
    const navigate = useNavigate();
    const { createImageUrl } = useAsset();
    const { fallbackImage } = useFallbackImage();
    return (
        <Box onClick={() => navigate(`${originalPath}`)} sx={{ cursor: "pointer", backgroundColor:"background.paper", padding:1 }}>
            <Grid container>
                <Grid item xs={4}>
                    <Box
                        component="img"
                        alt="Content simple thumbnail"
                        src={thumbnail ? createImageUrl(thumbnail) : fallbackImage}
                        sx={{ width: "100%" }}
                    />
                </Grid>
                <Grid item xs={8} paddingLeft={2.5}>
                    <Typography variant="h5" sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        width: "100%"
                    }}>{title}</Typography>
                    <RichText
                        html={description}
                        sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: "3",
                            WebkitBoxOrient: "vertical"
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}

export default CodeDetailsRelatedContentContentSimple;